<app-folder-dialog-content dialogTitle="folder_selector.create_folder"
                           submitBtnText="folder_selector.create"
                           [dialogRef]="dialogRef"
                           subtitleIcon="folder"
                           [subtitle]="data.parentFolder.getFullPathToStr()"
                           (onApply)="onApply($event)"></app-folder-dialog-content>
